var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  align-self: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 16px;\n  margin: 0;\n  background: ', ';\n  text-align: center;\n  line-height: 36px;\n  box-sizing: border-box;\n  position: relative;\n'], ['\n  display: inline-block;\n  align-self: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 16px;\n  margin: 0;\n  background: ', ';\n  text-align: center;\n  line-height: 36px;\n  box-sizing: border-box;\n  position: relative;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled, { withTheme } from 'styled-components';

var getIcon = function getIcon(_ref) {
  var user = _ref.user,
      theme = _ref.theme;

  if (user === 'BOT') {
    return React.createElement('img', { src: theme.robotIcon, width: '16px' });
  } else if (user === 'CUSTOMER') {
    return React.createElement('img', { src: theme.userIcon, width: '16px' });
  } else if (user === 'OPERATOR') {
    return React.createElement('img', { src: theme.userIcon, width: '16px' });
  } else if (user === 'ERROR') {
    return React.createElement('img', { src: theme.errorIcon, width: '14px' });
  }
};
var Icon = withTheme(getIcon);

var AvatarWrapper = styled.div(_templateObject, function (props) {
  return props.user === 'BOT' || props.user === 'OPERATOR' ? props.theme.lightColor : '#f4f4f4';
});

var Avatar = function Avatar(_ref2) {
  var user = _ref2.user;
  return React.createElement(
    AvatarWrapper,
    { user: user },
    React.createElement(Icon, { user: user })
  );
};

export default Avatar;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/message-list/message/avatar.js
// module id = 762
// module chunks = 1